import logo from './logo.svg';
// import './App.css';
// import FleetMap from './MapPage';

// function App() {
//   return (
// FleetMap()
//   );
// }

// export default App;
// src/App.jsx
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import FleetMap from './MapPage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/map" element={<FleetMap />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;